module.exports = __webpack_public_path__ + "img/merc_unboundtoken.edd201e.png";